var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-dialog",
    {
      ref: "promoterDialog",
      attrs: {
        "data-test": _vm.CypressTarget("PromoterDialog"),
        value: _vm.value,
        "prevent-close": _vm.promoterRequired
      },
      on: {
        input: function($event) {
          _vm.$emit("input", $event)
        }
      },
      scopedSlots: _vm._u([
        {
          key: "buttons",
          fn: function(props) {
            return [
              _c("q-btn", {
                attrs: {
                  label: _vm.$t("button.cancel"),
                  "data-test": _vm.CypressTarget("Cancel"),
                  color: _vm.SET_COLOR.buttons.cancel || "dark",
                  flat: ""
                },
                nativeOn: {
                  click: function($event) {
                    return props.cancel($event)
                  }
                }
              }),
              _c("q-btn", {
                attrs: {
                  "data-test": _vm.CypressTarget("Ok"),
                  disable: _vm.promoter === "",
                  label: _vm.$t("button.ok"),
                  color: _vm.SET_COLOR.buttons.ok || "dark",
                  flat: ""
                },
                on: {
                  click: function($event) {
                    _vm.setPromoter(props.ok, _vm.promoter)
                  }
                }
              })
            ]
          }
        }
      ])
    },
    [
      _c(
        "span",
        {
          attrs: { slot: "title", "data-test": _vm.CypressTarget("Title") },
          slot: "title"
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("dialog.promoterSelect.title")) + "\n  "
          )
        ]
      ),
      _c(
        "span",
        {
          attrs: { slot: "message", "data-test": _vm.CypressTarget("Text") },
          slot: "message"
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("dialog.promoterSelect.text")) + "\n  "
          )
        ]
      ),
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _vm.promoterList.length > 0
            ? _c(
                "q-field",
                [
                  _c("q-select", {
                    attrs: {
                      "data-test": _vm.CypressTarget("Select"),
                      "filter-placeholder": _vm.$t(
                        "dialog.promoterSelect.filterPlaceholder"
                      ),
                      "float-label": _vm.$t("dialog.promoterSelect.field"),
                      color: _vm.SET_COLOR.primary,
                      options: _vm.promoterList,
                      filter: ""
                    },
                    model: {
                      value: _vm.promoter,
                      callback: function($$v) {
                        _vm.promoter = $$v
                      },
                      expression: "promoter"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }